import { useEffect, useState } from "react";
import { Radar, Filter, CalendarPlus, CalendarCheck, FileText } from "lucide-react";

const STAGES = [
  { label: "Acquisizione", I: Radar, who: "TERMONLINE" },
  { label: "Profilazione", I: Filter, who: "TERMONLINE" },
  { label: "Appuntamento fissato", I: CalendarPlus, who: "TERMONLINE" },
  { label: "Sopralluogo", I: CalendarCheck, who: "Tua azienda" },
  { label: "Preventivo", I: FileText, who: "Tua azienda" },
];

export const PipelineStrip = () => {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setActive((v) => (v + 1) % STAGES.length), 1500);
    return () => clearInterval(t);
  }, []);
  return (
    <div data-testid="pipeline-strip" className="relative glass rounded-2xl p-2 sm:p-3 overflow-hidden">
      <div className="absolute top-1/2 inset-x-6 h-px bg-gradient-to-r from-[#4fc3f7]/0 via-[#4fc3f7]/30 to-[#ff5500]/0 hidden md:block" />
      <div className="absolute top-1/2 -translate-y-1/2 h-[2px] w-32 beam bg-gradient-to-r from-transparent via-[#ff5500] to-transparent hidden md:block" />
      <ol className="relative grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2">
        {STAGES.map(({ label, I, who }, i) => {
          const on = i === active;
          const done = i < active;
          return (
            <li key={label} data-testid={`pipeline-stage-${i}`}
              className={`relative flex items-center gap-3 rounded-xl px-3 py-3 transition-colors duration-500 ${on ? "bg-[#ff5500]/10" : "bg-white/[0.02]"} ${i === 4 ? "col-span-2 sm:col-span-1" : ""}`}>
              <span className={`shrink-0 w-9 h-9 grid place-items-center rounded-lg border transition-colors duration-500 ${on ? "border-[#ff5500] text-[#ff8a4c] shadow-[0_0_20px_-4px_#ff5500]" : done ? "border-[#4fc3f7]/50 text-[#7fd6fb]" : "border-white/10 text-slate-400"}`}>
                <I className="w-4 h-4" />
              </span>
              <span className="min-w-0">
                <span className="block font-mono text-[10px] text-slate-400">0{i + 1} · {who}</span>
                <span className={`block text-[13px] font-medium leading-tight transition-colors ${on ? "text-white" : "text-slate-300"}`}>{label}</span>
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
